module.exports = __webpack_public_path__ + "img/epicwin_en.a2331a6e.png";